import { OpenAIModel } from "@models/open-ai-gpt.model";
import { Tiktoken, getEncoding } from "js-tiktoken";

export const GptEncoding: Tiktoken = getEncoding('cl100k_base');
export const Gpt4oEncoding: Tiktoken = getEncoding('o200k_base');

export const MaxTokenList = [
    { model: OpenAIModel.GPT3_5Turbo, maxToken: 4096 },
    { model: OpenAIModel.GPT4, maxToken: 8192 },
    { model: OpenAIModel.GPT4TurboPreview, maxToken: 128000 },
    { model: OpenAIModel.GPT4Turbo, maxToken: 128000 },
    { model: OpenAIModel.GPT4Omni, maxToken: 128000 },
    { model: OpenAIModel.GPT4OmniMini, maxToken: 128000 }
];
